var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Pin",class:[_vm.sizeClass, _vm.colorClass]})
}
var staticRenderFns = []

export { render, staticRenderFns }